import { Injectable } from '@angular/core';
import { DatasourceTableQuery } from '@y42/datasource';
import { DateTimeService } from '@y42/date-time';
import { GitQuery } from '@y42/git';
import { Y42FeatureType } from '@y42/json-schema';
import { SqlModelingTableJobQuery } from '../datasource-table-job';
import { SqlModelingStoreQuery } from '../datasource/sql-modeling.store-query';
import { SqlModelingTableStore } from './sql-modeling-table.store';

@Injectable({ providedIn: 'root' })
export class SqlModelingTableQuery extends DatasourceTableQuery {
  constructor(
    protected readonly store: SqlModelingTableStore,
    protected readonly parentQuery: SqlModelingStoreQuery,
    protected readonly gitQuery: GitQuery,
    protected readonly modelingTableJobQuery: SqlModelingTableJobQuery,
    protected readonly dateTimeService: DateTimeService,
  ) {
    super(store, parentQuery, gitQuery, modelingTableJobQuery, dateTimeService);
  }

  readonly featureType = Y42FeatureType.SqlModel;
}
